// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__FDY3M","twoColumn":"Footer_twoColumn__j7r77","leftColumn":"Footer_leftColumn__8jdY8","rightColumn":"Footer_rightColumn__SnLrE"};